import { addYears, startOfDay, isAfter } from 'date-fns';
import compact from 'lodash/compact';
import { serviceModel } from "../../models";
export let AdvancedSetting = /*#__PURE__*/function (AdvancedSetting) {
  AdvancedSetting["Pause"] = "pause";
  AdvancedSetting["BillOnApproval"] = "billOnApproval";
  AdvancedSetting["Prorate"] = "prorate";
  AdvancedSetting["Optional"] = "optional";
  AdvancedSetting["LimitCharges"] = "limitCharges";
  AdvancedSetting["AutoPriceIncrease"] = "autoPriceIncrease";
  AdvancedSetting["QboClasses"] = "qboClasses";
  return AdvancedSetting;
}({});
export function getSettings(_ref) {
  let {
    service,
    isApprovedRelationship,
    allowToCustomizeQboClasses,
    QBO_CLASSES
  } = _ref;
  const isOngoing = serviceModel.isOngoing(serviceModel.billingTrigger(service));
  const isBilledUpfront = serviceModel.isBilledUpfront(service);
  const isSkipBillingOnAcceptance = serviceModel.isSkipBillingOnAcceptance(service);
  const isRecurring = serviceModel.isRecurring(serviceModel.billingTrigger(service));
  const isProrated = serviceModel.isProrated(service);
  const isPaused = serviceModel.isPaused(service);
  const isAwaitingApproval = serviceModel.isAwaitingApproval(service.status);
  return compact([isAwaitingApproval && isOngoing && {
    type: AdvancedSetting.Pause,
    label: 'Do not start automatic billing',
    info: 'The service will not be billed until you manually resume automatic billing for it.',
    disabled: isBilledUpfront ? !isSkipBillingOnAcceptance : isProrated,
    disabledTooltip: isBilledUpfront ? 'Services set to issue an invoice on proposal acceptance cannot be paused' : 'To pause automatic billing, remove proration'
  }, isAwaitingApproval && isOngoing && isBilledUpfront && {
    type: AdvancedSetting.BillOnApproval,
    label: isApprovedRelationship ? 'Issue an invoice immediately' : 'Charge this service on proposal acceptance',
    info: isApprovedRelationship ? 'An invoice for this service will be issued immediately once amendments are saved in addition to the invoices issued on the upcoming billing date and going forward. Invoices including this service will require an approval from your client until this amendment is approved.' : "The service will be charged on the day the proposal is accepted (even if it's not the set billing date) and continue issuing from the next scheduled billing date and going forward.",
    disabled: isPaused,
    disabledTooltip: 'Services with automatic billing set to paused cannot be charged on acceptance'
  }, isAwaitingApproval && isOngoing && !(isBilledUpfront && isSkipBillingOnAcceptance) && {
    type: AdvancedSetting.Prorate,
    label: 'Prorate the first payment',
    info: 'When enabled, the price of the first invoice will be calculated in proportion to the number of days the agreement was in effect during the billing cycle',
    disabled: isPaused,
    disabledTooltip: 'Services with automatic billing set to paused cannot be prorated'
  }, isAwaitingApproval && !isApprovedRelationship && {
    type: AdvancedSetting.Optional,
    label: 'Mark this service as optional',
    info: 'Mark a service as optional if you would like to give your client the option to include the service in this agreement'
  }, isAwaitingApproval && isRecurring && {
    type: AdvancedSetting.LimitCharges,
    label: 'Bill a limited number of times',
    info: 'Set a limit on how many times this service can be billed'
  }, serviceModel.supportsPriceIncrease(service) && {
    type: AdvancedSetting.AutoPriceIncrease,
    label: 'Set an automatic annual price increase',
    info: 'Automatic price increase will be applied once a year unless manually changed or cancelled.'
  }, QBO_CLASSES && allowToCustomizeQboClasses && {
    type: AdvancedSetting.QboClasses,
    label: 'Override QuickBooks Online class assignment',
    info: 'Set the class of this service when syncing invoices to QuickBooks Online.'
  }]);
}
export function getValidIncreaseOn(increaseOn, now) {
  const today = startOfDay(now);
  return isAfter(increaseOn, today) ? increaseOn : addYears(increaseOn, 1);
}